import styled, { css } from 'styled-components/macro';
import {
  white,
  graySecondaryDark,
  grayDividerSecondary,
  graySecondary,
} from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

export const SectionWrapper = styled.section`
  display: ${({ displayGrid }) => (displayGrid ? `grid` : `flex`)};
  justify-content: space-between;
  ${({ flexEnd }) =>
    flexEnd &&
    css`
      align-content: flex-end;
    `};
  ${({ rowDirection }) => (rowDirection ? `row` : `column`)};
  flex-wrap: wrap;
  flex-direction: ${({ rowDirection }) => (rowDirection ? `row` : `column`)};
  background-color: ${({ bgTransparent }) =>
    bgTransparent ? `transparent` : `${white}`};
  border-radius: 3px;
  box-shadow: ${({ bgTransparent }) =>
    bgTransparent ? `none` : `1px 1px 1px 0 rgba(0, 0, 0, 0.1)`};

  padding: ${({ noPadding }) => (noPadding ? `0` : `40px 20px`)};
  ${({ columns }) =>
    columns &&
    css`
      > section {
        flex: 0 1 calc(100%);
        margin-bottom: 10px;
        ${media.desktop`
          margin-bottom: 0;
          flex: 0 1 calc(${100 / columns}% - 10px);
        `}
      }
    `}
  ${({ displayGrid }) =>
    displayGrid &&
    css`
      grid-template-columns: repeat(2, 1fr);
      grid-auto-columns: 100%;
      grid-column-gap: 15px;
      grid-row-gap: 25px;
      > h2 {
        grid-column: span 2;
        margin-bottom: 0;
      }
      ${media.desktop`
          padding: ${({ noPadding }) => (noPadding ? `0` : `40px 20px`)};
          grid-template-columns: ${({ gridCol }) =>
            gridCol ? `repeat(${gridCol}, 1fr)` : `repeat(3, 1fr)`};

          > h2 {
            grid-column:  ${({ gridCol }) =>
              gridCol ? `span ${gridCol}` : `span 3`};
          }

        `}
    `}
`;

export const InlineChildrenWrapper = styled.div`
  display: inline-flex;
  ${({ fullWidth }) => fullWidth && 'width: 100%;'}
`;

export const SubsectionWrapper = styled.section`
  padding: 10px 20px;
  background-color: ${white};
  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  ${media.desktop`
    padding: 18px 29px;
  `}
  border-bottom: ${({ border }) =>
    border && `1px solid ${grayDividerSecondary}`};
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  ${fontSize(12)};
  ${media.desktop`
    ${fontSize(14)}
    padding: 40px 29px 0 29px;
  `}
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SectionTitle = styled.h2`
  margin-bottom: 15px;
  ${fontSize(14)};
  color: ${graySecondaryDark};
`;

export const SectionSubtitle = styled.h3`
  margin-bottom: 16px;
  ${fontSize(12)};
  color: ${graySecondaryDark};
  margin-bottom: 15px;
  font-weight: normal;
`;

export const SubsectionHeader = styled(SectionHeader)`
  padding: 0;
  ${media.desktop`
    padding: 0;
  `}
`;
export const SectionSmallText = styled.p`
  ${fontSize(10)};
  margin: 5px 0;
  line-height: 1.2;
  color: ${graySecondary};
  ${media.desktop`
    ${({ smaller }) => (smaller ? fontSize(10) : fontSize(12))};
  `}
`;

export const Footer = styled.div`
  display: flex;

  align-items: center;
`;

export const FooterText = styled.p`
  ${fontSize(11)};
`;
